import "./GreatTaipei.module.css";
import PrimaryNavigation from "@/reusable_sections/Header";
import TheFireTheFlour from "./sections/TheFireTheFlour";
import TheLineup from "./sections/TheLineup";
import ThePalette from "./sections/ThePalette";
import FacebookHighlights from "./sections/FacebookHighlights";
import Footer from "@/reusable_sections/Footer";
export default function GreatTaipeiPage() {
  return <div>
      <PrimaryNavigation />
      <TheFireTheFlour />
      <TheLineup />
      <ThePalette />
      <FacebookHighlights />
      <Footer />
    </div>;
}